module.exports = __webpack_public_path__ + "static/media/img_31.6d14a187.png";